<div id="chromebookdetailsPanel" class="main_content" [class.chromebook-background]="isChromeBook" *ngIf="!isNewPenel && !showPantherLakePageComponent">
  <div id="detailPageName" class="ftag-info-wrapper processor-wrapper detail_{{detailsPageName}}"
    (scroll)="onScroll($event)">
    <div id="panelData" *ngFor="let panel of panelData">
      <app-panel [pageName]="detailsPageName" [panelData]="panel"></app-panel>
    </div>
  </div>
  <div *ngIf="panelData?.length===0" class="nodetailPage" id="detailsPanels">
    <div>
      Work in progress
    </div>
  </div>
</div>
<!-- IJR-1736 12th genGaming starts -->
<div id="panelData12Gen" class="new-main-content" *ngIf="isNewPenel && !showPantherLakePageComponent">
  <app-new-penel [pageName]="detailsPageName" [panelData]="panelData"></app-new-penel>
  <!-- Added new panel for new mobile enhancements -->
</div>
<!-- IJR-1736 12th genGaming end -->

<div *ngIf="showPantherLakePageComponent && detailsPageName != 'processor' && detailsPageName != 'aidemos'">
  <app-panther-lake-details-page [panelData]="panelData"></app-panther-lake-details-page>
</div>

<div *ngIf="showPantherLakePageComponent && detailsPageName === 'processor'">
  <app-processor-page [panelData]="panelData"></app-processor-page>
</div>

<div *ngIf="showPantherLakePageComponent && detailsPageName === 'ulthreedmark'">
  <app-ulthreedmark [panelData]="panelData"></app-ulthreedmark>
</div>

<div *ngIf="showPantherLakePageComponent && detailsPageName === 'aidemos'">
  <app-ai-demos [panelData]="panelData"></app-ai-demos>
</div>